import { IdValueGeneric, IdValueWithRegions } from 'interfaces'
import { SpecificConditionAnswer } from './SpecificConditions'
import { VehicleSpec } from '../../api/vehicle/interfaces'

export interface Vehicle {
  initialized?: boolean
  id?: number
  name?: string
  favorite?: boolean
  type?: IdValueGeneric<number, string>
  year?: IdValueWithRegions<number, string>
  make?: IdValueWithRegions<number, string>
  model?: IdValueWithRegions<number, string>
  subModel?: IdValueWithRegions<number, string>
  modelType?: IdValueGeneric<number, string>
  engine?: IdValueWithRegions<number, string>
  vin?: string
  state?: string
  plate?: string
  specificConditions?: Array<SpecificConditionAnswer>
  decodeSource?: decodeSource
  vehicleSpecs?: VehicleSpec[]
  regionId?: number
}

export enum VehicleType {
  CarTruck = 'Car/Truck',
  Motorcycle = 'Motorcycle',
  Boat = 'Boat',
}

export enum decodeSource {
  vin = 'VIN',
  LicensePlate = 'License Plate',
  Aaia = 'AAIA',
  Aces = 'ACES',
  Ymme = 'YMME',
  YmmeNumber = 'YMME Number',
}
